import React from "react"
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap"
import TableView, {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../../component/atoms/Tabel/index.jsx"
import { Card, CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { useSelector } from "react-redux"
import { EmptyCard, TableSkeleton } from "../../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { getUrlParsingPageFilter } from "../../../../../../config/EndpointCollection.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../../constants/ImageConstants.js"

export const TableList = ({ data, general, changePage, history, activeFilter }) => {
  const { t } = useTranslation()

  const { General } = useSelector((state) => state)
  const uiCode = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.code ?? "-"}</p>
      </>
    )
  }
  const uiName = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.name ?? "-"}</p>
      </>
    )
  }

  const uiTypeName = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.plant_type ?? "-"}</p>
      </>
    )
  }

  const uiAction = (e) => {
    return (
      <>
        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
          <a
            onClick={() => {
              history.push(RoutesConstants.MASTER_DATA.PACKAGE.DETAIL(e.id))
            }}
            className="btn btn-icon btn-hover-primary btn-sm mx-3">
            <DetailSvgIcon></DetailSvgIcon>
          </a>
        </OverlayTrigger>
      </>
    )
  }

  function uiRegional(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder mb-1 font-size-lg"}>
          {e?.regional_name || "-"}
        </div>
        <div>{e?.regional_code || "-"}</div>
      </div>
    )
  }

  const uiStatus = (e) => {
    const status = e?.status
    if (status === "Active") {
      return <Badge variant="primary">{t("label_active")}</Badge>
    } else {
      return (
        <Badge className={"bg-neutral-gray text-neutral-white"} variant="secondary">
          {t("label_inactive")}
        </Badge>
      )
    }
  }

  function uiTreatment(e) {
    return <div style={{ textAlign: "start" }}>{e?.treatment_total || "0"}</div>
  }

  const columns = [
    {
      dataField: "code",
      text: t("table_header_package_id").toUpperCase(),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      formatExtraData: {
        externalStyle: uiCode
      }
    },
    {
      dataField: "name",
      text: t("table_header_package_name").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      headerStyle: () => {
        return { width: "15%" }
      }
    },
    {
      dataField: "plantType.name",
      text: t("table_header_plant_type").toUpperCase(),
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiTypeName
      }
    },
    {
      dataField: "treatment_total",
      text: t("table_header_total_treatment").toUpperCase(),
      sort: false,
      align: "center",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiTreatment
      }
    },
    {
      dataField: "regional.name",
      text: t("label_regional").toUpperCase(),
      sort: true,
      onSort: (field, order) => {
        let param = getUrlParsingPageFilter({
          ...initialFilterTable,
          sort: field + "," + order
        })
        history.push({ pathname: location.pathname, search: param })
      },
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiRegional
      }
    },
    {
      dataField: "status",
      text: t("label_status").toUpperCase(),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiStatus
      }
    },

    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  return (
    <Card className="card-shadowless">
      <CardBody>
        {General?.loading ? (
          <TableSkeleton column={5} row={10} />
        ) : data?.pageData?.length === 0 ? (
          <EmptyCard
            subtitle={activeFilter ? t("messages_response_empty_search_subtitle") : ""}
            image={
              activeFilter
                ? ILLUSTRATION_CONSTANTS.EMPTY_DESKTOP
                : ILLUSTRATION_CONSTANTS.NOT_FOUND_DESKTOP
            }
            body={
              activeFilter
                ? t("messages_response_searching_not_found")
                : t("messages_response_empty_state", { name: "paket" })
            }
          />
        ) : (
          <></>
        )}
        <TableView
          callbackAfterPageChange={changePage}
          columnProperties={columns}
          dataTable={data?.pageData || []}
          currentPage={data?.page?.currentPage || 0}
          currentElement={data?.page?.currentElement || 20}
          totalCount={data?.page?.totalCount || 0}
          loadingGetData={general?.loading}
          ignoreSinglePage
        />
      </CardBody>
    </Card>
  )
}
